"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var LinearRing_1 = __importDefault(require("./LinearRing"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var Validators_1 = __importDefault(require("../shared/Validators"));
var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    function Polygon(externalRing) {
        var internalRings = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            internalRings[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.externalRing = new LinearRing_1.default(externalRing && externalRing.coordinatesFlat());
        _this.internalRings = new Array();
        internalRings.forEach(function (r) { return _this.internalRings.push(r); });
        return _this;
    }
    Object.defineProperty(Polygon.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.Polygon;
        },
        enumerable: true,
        configurable: true
    });
    Polygon.prototype.coordinatesFlat = function () {
        return lodash_1.default.flatMap(__spreadArrays([this.externalRing], this.internalRings), function (r) { return r.coordinatesFlat(); });
    };
    Polygon.prototype.coordinates = function () {
        return __spreadArrays([this.externalRing], this.internalRings).map(function (r) { return r.coordinates(); });
    };
    Polygon.prototype._ts = function () {
        return Geometry_1.default._factory.createPolygon(this.externalRing._ts(), this.internalRings.map(function (r) { return r._ts(); }));
    };
    Polygon.prototype._clone = function (convert) {
        var rings = __spreadArrays([this.externalRing], this.internalRings);
        rings = rings.map(function (r) { return r.clone(convert); });
        var tmpRing = rings.shift();
        return new (Polygon.bind.apply(Polygon, __spreadArrays([void 0, tmpRing], rings)))();
    };
    Polygon.prototype.forEachCoordinates = function (callback) {
        [this.externalRing].concat(this.internalRings).forEach(function (r) { return r.forEachCoordinates(callback); });
    };
    Polygon.fromNumbers = function () {
        var coordinates = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            coordinates[_i] = arguments[_i];
        }
        Validators_1.default.validateCoordinateNumbers(coordinates, 1);
        var rings = coordinates.map(function (cs) { return LinearRing_1.default.fromNumbers.apply(LinearRing_1.default, cs); });
        var polygon = new Polygon(rings[0]);
        for (var i = 1; i < rings.length; i++) {
            polygon.internalRings.push(rings[i]);
        }
        return polygon;
    };
    Polygon._from = function (polygon) {
        var geom = new Polygon(LinearRing_1.default._from(polygon.getExteriorRing()));
        var innerRingCount = polygon.getNumInteriorRing();
        for (var i = 0; i < innerRingCount; i++) {
            geom.internalRings.push(LinearRing_1.default._from(polygon.getInteriorRingN(i)));
        }
        return geom;
    };
    return Polygon;
}(Geometry_1.default));
exports.default = Polygon;
